module.exports = __webpack_public_path__ + "static/equipmentLeasing-6fef8855c9aee01842b392427399506b.png";